<!-- 嵌入式-产品入库管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 产品入库
      </el-button>
      <div class="former">
        <select2
          labelName="NameNumber"
          v-model="former.DciProductModelID"
          url="dci/model/product/list?order=name"
          clearable
          placeholder="选择产品型号"
          no-data-text="没有产品型号"
          :urlParams="{
            where: {},
          }"
          q="NameNumber:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2
        >&nbsp;
        <el-input
          v-model.trim="former['SN|Remark:like']"
          placeholder="输入产品SN"
          @keydown.enter.native="onSubmitQuery"
        >
        </el-input
        >&nbsp;
        <select2
          labelName="Value"
          valueKey="Key"
          v-model="former.Status"
          url="dci/product/stock-status-list"
          clearable
          placeholder="请选择状态"
          no-data-text="没有状态"
        ></select2
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="DciProductModel.Name" label="产品型号名称" />
      <el-table-column prop="DciProductModel.Number" label="产品型号" />
      <el-table-column prop="SN" label="产品SN" >
         <template slot-scope="{ row }">
          <el-tag>
            {{ row.SN }}
          </el-tag>
           <el-tag type="success" v-if="row.Remark">
            {{ row.Remark }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="" label="入库日期" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.StockinAt">
            {{ scope.row.StockinAt.substring(0, 10) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="StatusName" label="状态" width="150">
        <template slot-scope="{ row }">
          <el-tag v-if="row.Status === 1" type="warning">
            {{ row.StatusName }}
          </el-tag>
          <el-tag v-else type="success">
            {{ row.StatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="140" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="详情"
          >
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteClick(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="删除"
      :visible.sync="deleteVisible"
      :close-on-click-modal="false"
      @close="onCloseDel"
      width="40%"
    >
      <el-form
        ref="deleteItemForm"
        label-width="100px"
        :model="deleteItem"
        :rules="deleteRules"
      >
        <el-form-item label="删除类型">
          <el-radio-group v-model="deleteItem.Type">
            <el-radio :label="0">删除该产品及关联配件</el-radio>
            <el-radio :label="1">仅删除该产品,保留配件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="Status" v-if="deleteItem.Type !== 0">
          <select2
            labelName="Value"
            valueKey="Key"
            style="width: 100%"
            :clearable="false"
            v-model="deleteItem.Status"
            url="dci/accessory/stock-status-list"
            placeholder="请选择状态"
          ></select2>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseDel">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onDeleteItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
    <create
      v-model="item"
      :visible.sync="createVisible"
      @form:saved="getItemList"
    />
    <edit
      v-model="item"
      :visible.sync="editVisible"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import Create from "./create.vue";
import Edit from "./edit.vue";

export default {
  components: {
    Create,
    Edit,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        DciProductModelID: "",
        Status: "",
        "SN:like": "",
      },
      item: this.getEmptyItem(),
      deleteItem: {
        ID: -1,
        Type: 0,
        Status: null,
      },
      deleteRules: {
        Type: [
          { required: true, message: "删除类型不能为空", trigger: "blur" },
        ],
        Status: [{ required: true, message: "状态不能为空", trigger: "blur" }],
      },
      createVisible: false,
      editVisible: false,
      deleteVisible: false,
    };
  },
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/product/stock-in-list", {
          params: {
            where: this.former,
            ...this.pager,
            with: ["DciProductModel", "DciAccessories.DciAccessoryModel"],
            order: ["-stockin_at", "-sn"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.createVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.editVisible = true;
    },
    onCloseDel() {
      this.deleteVisible = false;
      this.$refs.deleteItemForm.resetFields();
    },
    onDeleteClick(row) {
      this.deleteVisible = true;
      this.deleteItem.ID = row.ID;
      this.deleteItem.Type = 0;
      this.deleteItem.Status = null;
    },
    onDeleteItem() {
      this.$refs.deleteItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$axios
          .request({
            url: "dci/product/stock-in-delete",
            method: "post",
            data: this.deleteItem,
          })
          .then(() => {
            this.getItemList();
            this.$message.success("删除成功");
            this.deleteVisible = false;
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      });
    },
    getEmptyItem() {
      return {};
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
  },
};
</script>
